import { render, staticRenderFns } from "./RateCourses.vue?vue&type=template&id=ce80a86e&scoped=true&"
import script from "./RateCourses.vue?vue&type=script&lang=js&"
export * from "./RateCourses.vue?vue&type=script&lang=js&"
import style0 from "./RateCourses.vue?vue&type=style&index=0&id=ce80a86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce80a86e",
  null
  
)

export default component.exports